import { createSelector, createFeatureSelector } from '@ngrx/store';
import { ApiDataState } from './api-data.state';

export const selectApiDataState =
  createFeatureSelector<ApiDataState>('apiData');

export const selectPreAuthRequest = createSelector(
  selectApiDataState,
  (state: ApiDataState) => state.preAuthRequest
);

export const selectCaptchaResponse = createSelector(
  selectApiDataState,
  (state: ApiDataState) => state.captchaResponse
);

export const selectPreAuthResponse = createSelector(
  selectApiDataState,
  (state: ApiDataState) => state.preAuthResponse
);

export const selectPickupDateHoursPeriodResponse = createSelector(
  selectApiDataState,
  (state: ApiDataState) => state.pickupDateHoursPeriodResponse
);

export const selectPickupResponse = createSelector(
  selectApiDataState,
  (state: ApiDataState) => state.pickupResponse
);
